import { createActionCreators } from "../utils/actionCreators";

export const {
    request: addEmploymentRequest,
    success: addEmploymentSuccess,
    failure: addEmploymentFailure
} = createActionCreators('ADD_EMPLOYMENT');

export const {
    request: removeEmploymentRequest,
    success: removeEmploymentSuccess,
    failure: removeEmploymentFailure
} = createActionCreators('REMOVE_EMPLOYMENT');

export const {
    request: getEmploymentsRequest,
    success: getEmploymentsSuccess,
    failure: getEmploymentsFailure
} = createActionCreators('GET_EMPLOYMENTS');

export const {
    request: confirmEmploymentRequest,
    success: confirmEmploymentSuccess,
    failure: confirmEmploymentFailure
} = createActionCreators('CONFIRM_EMPLOYMENT');

export const {
    request: updateEmploymentsRequest,
    success: updateEmploymentsSuccess,
    failure: updateEmploymentsFailure
} = createActionCreators('UPDATE_EMPLOYMENTS');

export const {
    request: updateEmploymentUnitsRequest,
    success: updateEmploymentUnitsSuccess,
    failure: updateEmploymentUnitsFailure
} = createActionCreators('UPDATE_EMPLOYMENTUNITS');